import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Col, Row, Button, Form, FormGroup, Label, Input, Modal, ModalHeader, ModalBody } from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { SelectTipoHabilitacion } from "./TiposHabilitacion";
import Header from "../../../layout/Header/Header";
import Get from "../../Get";

const CAMPOS_ORDEN = [
  ["tipo", "Tipo"],
  ["marca", "Marca"],
  ["color", "Color"],
  ["proveedor", "Proveedor"],
  ["alias", "Alias (como lo conocen)"],
];

function HabilitacionCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_HABILITACION = process.env.REACT_APP_URL_HABILITACION;
 
  const [nombre, setNombre] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [unidad, setUnidad] = useState("");
  const [selectedUnidad, setSelectedUnidad] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [costo, setCosto] = useState("");
  // Columnas de la Orden de Produccion (PDF de la orden de maquila).
  const [datosOrden, setDatosOrden] = useState({ tipo: "", marca: "", color: "", proveedor: "", alias: "" });


  const [validaBoton, setValidaBoton] = useState(true);


  const saveHabilitacion = async (event) => {
    event.preventDefault();
    setValidaBoton(false);
    try {
      await axios
        .post(
          URL_HABILITACION,
          {
            nombre,
            descripcion,
            costo,
            unidad: selectedUnidad,
            observaciones,
            ...datosOrden,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )   .then(() => {
                  axios.post(
                    URL_LOGS,
                    {
                      tipo: "Crear Habilitacion",
                      detalle: `${nombre}`,
                      user: user.id,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  );
                  Swal.fire("Good job!", "Creado con exito", `success`);
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000);
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                  setValidaBoton(true)
                });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`,
      });
      console.log(error);
    }
  };


  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_habilitacion ? (
        <div className="card container">
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <i className="fas fa-tag" style={{ marginRight: 8, color: "#8b5cf6" }} />
                Nueva Habilitacion
              </h3>
            </div>
          </div>
          {/* <Get/> */}
          <Form onSubmit={saveHabilitacion}>
            <div className="form-section">
              <div className="form-section-header">
                <i className="fas fa-tag" />
                <span className="form-section-title">Datos de la Habilitacion</span>
              </div>
              <div className="form-section-body">
            <Row>

              <Col md={3}>
                <Label>Nombre</Label>
                <Input
                  type="text"
                  placeholder="Nombre"
                  value={nombre}
                  required
                  onChange={(e) => {
                    setNombre(e.target.value);
                  }}
                />
              </Col>

              <Col md={3}>
                <Label>Descripcion</Label>
                <Input
                  type="text"
                  placeholder="Descripcion"
                  value={descripcion}
                  required
                  onChange={(e) => {
                    setDescripcion(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Unidad</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedUnidad}
                  required
                  onChange={(e) => {
                    setSelectedUnidad(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="Piezas">Piezas</option>
                  <option value="Metros">Metros</option>
                  <option value="Kilos">Kilos</option>
                </Input>
              </Col>
              <Col md={3}>
                <Label>Costo</Label>
                <Input
                  type="text"
                  placeholder="Costo"
                  value={costo}
                  required
                  onChange={(e) => {
                    setCosto(e.target.value);
                  }}
                />
              </Col>
             
             
            </Row>
            <Row>
              {CAMPOS_ORDEN.map(([campo, etiqueta]) => (
                <Col md={3} key={campo}>
                  <Label>{etiqueta}</Label>
                  {campo === "tipo" ? (
                    <SelectTipoHabilitacion required value={datosOrden.tipo} onChange={(v) => setDatosOrden({ ...datosOrden, tipo: v })} />
                  ) : (
                    <Input
                      type="text"
                      value={datosOrden[campo] || ""}
                      onChange={(e) => setDatosOrden({ ...datosOrden, [campo]: campo === "alias" ? e.target.value : e.target.value.toUpperCase() })}
                    />
                  )}
                </Col>
              ))}
            </Row>
            <Row>
              <Col md={6}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>

            </Row>
              </div>
            </div>
            <br />
            <div className="submit-bar">
            <Button
              href="/ListadoHabilitacion"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
              </Button>
            )}
            </div>
          </Form>
          <br />

         
        </div>
      ) : undefined}
    </>
  );
}

export default HabilitacionCreate;
